export const getLocalStorageItem = <T>(key: string): T | null => {
  const item = localStorage.getItem(`tournated:${key}`);
  if (item === null) return null;

  try {
    return JSON.parse(item) as T;
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: unknown) => {
  localStorage.setItem(`tournated:${key}`, JSON.stringify(value));
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(`tournated:${key}`);
};
